// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import List from './pages/List';
import Account from './pages/Account';
import ManagementDashboard from './pages/ManagementDashboard';
import Custormersc from './pages/Customers';
import CustomerUser from './pages/CustomerUser';
import Orders from './pages/Orders';
import Campaign from './pages/CampaignManagement';
import CustomerDetails from './pages/CustomerDetails';
import EditUser from './pages/EditUser';
import UserDetails from './pages/UserDetails';
import Cart from './pages/Cart';
import ProductDetail from './pages/ProductDetail';
import PrivateRoute from './components/PrivateRoute';
import DebtAging from './pages/DebtAging';
import MyDebtAging from './pages/MyDebtAging';
import OrderDetail from './pages/OrderDetail';
import AddUser from './pages/AddUser';
import Users from './pages/Users';
import SahaSatis from './pages/SahaSatis';
import LoginSahaSatis from './pages/LoginSahaSatis';
import DashboardV2 from './v2/pages/DashboardV2';
import ProductsV2 from './v2/pages/ProductsV2';
import CartV2 from './v2/pages/CartV2';
import AccountV2 from './v2/pages/AccountV2';
import OrdersV2 from './v2/pages/OrdersV2';
import QuotesV2 from './v2/pages/QuotesV2';
import QuoteDetailV2 from './v2/pages/QuoteDetailV2';
import DebtV2 from './v2/pages/DebtV2';
import V2Shell from './v2/components/V2Shell';
import AdminShell from './v2/components/admin/AdminShell';
import AdminOverviewV2 from './v2/pages/admin/AdminOverviewV2';
import AdminCustomersV2 from './v2/pages/admin/AdminCustomersV2';
import AdminCustomerDetailV2 from './v2/pages/admin/AdminCustomerDetailV2';
import AdminOrdersV2 from './v2/pages/admin/AdminOrdersV2';
import AdminQuotesV2 from './v2/pages/admin/AdminQuotesV2';
import AdminQuoteDetailV2 from './v2/pages/admin/AdminQuoteDetailV2';
import AdminDebtV2 from './v2/pages/admin/AdminDebtV2';
import AdminUsersV2 from './v2/pages/admin/AdminUsersV2';
import AdminLoginsV2 from './v2/pages/admin/AdminLoginsV2';
import AdminCampaignsV2 from './v2/pages/admin/AdminCampaignsV2';
import AdminAnnouncementsV2 from './v2/pages/admin/AdminAnnouncementsV2';
import LoginV2 from './v2/pages/LoginV2';
import EskiYonlendir from './v2/components/EskiYonlendir';

function App() {
return (
  <Router>
    <Routes>
      {/* ===== v2 GECISI (2026-09-26): eski arayuz kapatildi. Geri donus: ~/b2b_app/GECIS_GERI_DONUS.md ===== */}
      <Route path="/login" element={<LoginV2 />} />
      <Route path="/v2/login" element={<Navigate to="/login" replace />} />

      <Route path="/v2/admin" element={<AdminShell />}>
        <Route index element={<AdminOverviewV2 />} />
        <Route path="customers" element={<AdminCustomersV2 />} />
        <Route path="customers/:kod" element={<AdminCustomerDetailV2 />} />
        <Route path="orders" element={<AdminOrdersV2 />} />
        <Route path="quotes" element={<AdminQuotesV2 />} />
        <Route path="quotes/:no" element={<AdminQuoteDetailV2 />} />
        <Route path="debt" element={<AdminDebtV2 />} />
        <Route path="users" element={<AdminUsersV2 />} />
        <Route path="logins" element={<AdminLoginsV2 />} />
        <Route path="campaigns" element={<AdminCampaignsV2 />} />
        <Route path="announcements" element={<AdminAnnouncementsV2 />} />
        <Route path="*" element={<Navigate to="/v2/admin" replace />} />
      </Route>

      <Route path="/v2" element={<V2Shell />}>
        <Route index element={<DashboardV2 />} />
        <Route path="products" element={<ProductsV2 />} />
        <Route path="cart" element={<CartV2 />} />
        <Route path="account" element={<AccountV2 />} />
        <Route path="orders" element={<OrdersV2 />} />
        <Route path="quotes" element={<QuotesV2 />} />
        <Route path="quotes/:no" element={<QuoteDetailV2 />} />
        <Route path="debt" element={<DebtV2 />} />
        <Route path="*" element={<Navigate to="/v2" replace />} />
      </Route>

      {/* eski adresler -> v2 karsiliklari (musteri / admin) */}
      <Route path="/" element={<EskiYonlendir />} />
      <Route path="/about" element={<EskiYonlendir />} />
      <Route path="/list" element={<EskiYonlendir musteri="/v2/products" />} />
      <Route path="/product/:productCode" element={<EskiYonlendir musteri="/v2/products" />} />
      <Route path="/account" element={<EskiYonlendir musteri="/v2/account" />} />
      <Route path="/cart" element={<EskiYonlendir musteri="/v2/cart" />} />
      <Route path="/orders" element={<EskiYonlendir musteri="/v2/orders" admin="/v2/admin/orders" />} />
      <Route path="/orders/:orderNo" element={<EskiYonlendir musteri="/v2/orders" admin="/v2/admin/orders?q=:orderNo" />} />
      <Route path="/my-debt-aging" element={<EskiYonlendir musteri="/v2/debt" admin="/v2/admin/debt" />} />
      <Route path="/debt-aging" element={<EskiYonlendir musteri="/v2/debt" admin="/v2/admin/debt" />} />
      <Route path="/managementdashboard" element={<EskiYonlendir />} />
      <Route path="/customers/*" element={<EskiYonlendir admin="/v2/admin/customers" />} />
      <Route path="/customer/:code" element={<EskiYonlendir admin="/v2/admin/customers/:code" />} />
      <Route path="/customeruser" element={<EskiYonlendir admin="/v2/admin/users" />} />
      <Route path="/users" element={<EskiYonlendir admin="/v2/admin/users" />} />
      <Route path="/add-user" element={<EskiYonlendir admin="/v2/admin/users" />} />
      <Route path="/edit-user/:id" element={<EskiYonlendir admin="/v2/admin/users" />} />
      <Route path="/user/:userId" element={<EskiYonlendir admin="/v2/admin/users" />} />
      <Route path="/campaigns/*" element={<EskiYonlendir admin="/v2/admin/campaigns" />} />
      {/* SahaSatis kapatildi */}
      <Route path="/sahasatis" element={<EskiYonlendir />} />
      <Route path="/LoginSahaSatis" element={<EskiYonlendir />} />
      <Route path="*" element={<EskiYonlendir />} />
    </Routes>
  </Router>
);
}

export default App;